import { Identifiable } from 'app/armp/models/identifiable';

export class System extends Identifiable<number> {
  name?: string;
  urlTemplate?: string;
  orderUrlTemplate?: string;
}
